<template>
  <div class="enzyme-game-pro" dir="rtl">
    <transition name="fade">
      <div v-if="showTutorial" class="tutorial-overlay">
        <div class="tutorial-card">
          <img src="@/assets/images/game/logo.gif" class="logo" />
          <h3>راهنمای پودر لکه بر سپید +</h3>
          <p class="tutorial-text mx-2">بازی کن، جایزه بگیر.</p>
          <div class="guide-scroll">
            <div class="marquee-wrapper">
              <div class="marquee-row marquee-content">
                <div
                  v-for="(item, index) in guideItems"
                  :key="index"
                  class="guide-row"
                >
                  <div class="g-stain">
                    <img :src="item.stain" />
                    <span>متخصص {{ item.label }}</span>
                  </div>
                  <v-icon class="goldenrod animated-arrow"
                    >mdi-transfer-up</v-icon
                  >
                  <div class="g-enzyme">
                    <img :src="item.enzyme" />
                    <span>{{ item.eName }}</span>
                  </div>
                </div>

                <div
                  v-for="(item, index) in guideItems"
                  :key="'dup-' + index"
                  class="guide-row"
                >
                  <div class="g-stain">
                    <img :src="item.stain" />
                    <span>متخصص {{ item.label }}</span>
                  </div>
                  <v-icon class="goldenrod animated-arrow"
                    >mdi-transfer-up</v-icon
                  >
                  <div class="g-enzyme">
                    <img :src="item.enzyme" />
                    <span>{{ item.eName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row">
            <img class="iconOxygen" src="@/assets/images/game/oxygen.gif" />
            <p class="turbo-hint">
              با ۳۰۰ امتیاز، <b>توربو اکسیژن</b> فعال می‌شود!
            </p>
          </div>
          <v-btn
            class="btn-warning rounded-lg elevation-5 w-100"
            @click="startGame"
            >فهمیدم، شروع ماجراجویی</v-btn
          >
        </div>
      </div>
    </transition>
    <div class="game-header">
      <div class="header-right">
        <v-btn icon dark x-small @click="toggleMute" class="icon-header">
          <v-icon size="18">{{
            isMuted ? "mdi-volume-off" : "mdi-volume-high"
          }}</v-icon>
        </v-btn>

        <div class="header-right2">
          <v-btn
            icon
            dark
            x-small
            @click="
              showTutorial = true;
              togglePause();
            "
            class="icon-header mt-1"
          >
            <v-icon size="18">mdi-help-circle</v-icon>
          </v-btn>
          <v-btn icon dark x-small @click="togglePause" class="icon-header">
            <v-icon size="18">{{
              gamePaused ? "mdi-play" : "mdi-pause"
            }}</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="header-center">
        <div class="timer-display" :class="{ 'low-time': timeLeft < 10 }">
          <span class="time-num">{{ timeLeft }}</span>
          <span class="time-unit">ثانیه</span>
        </div>
        <div class="score-display">
          <span class="score-label">امتیاز:</span>
          <span class="score-num">{{ score }}</span>
        </div>
      </div>

      <div class="header-left">
        <div class="lives-box">
          <img
            v-for="n in 3"
            :key="'h' + n"
            :src="
              n <= lives
                ? require('@/assets/images/game/heart.webp')
                : require('@/assets/images/game/heart_empty.webp')
            "
            class="heart-icon"
          />
        </div>
        <div class="user-info-mini" @click="openEditPhone">
          <v-icon x-small color="white">mdi-pencil</v-icon>
          <span class="phone-text">{{ phoneNumber || "ثبت شماره" }}</span>
        </div>
      </div>
    </div>

    <div class="game-viewport" ref="gameArea">
      <canvas ref="particleCanvas" class="particle-layer"></canvas>
      <div class="turbo-bubbles" v-if="turboActive">
        <div
          v-for="i in 8"
          :key="i"
          class="bubble"
          :style="bubbleStyle(i)"
        ></div>
      </div>

      <div
        v-if="!playing && !showTutorial && !gameOverDialog"
        class="tutorial-overlay"
      >
        <v-btn
          fab
          x-large
          color="warning"
          @click="gamePaused ? togglePause() : startGame()"
        >
          <v-icon large class="goldenrod rounded-pill">{{
            gamePaused ? "mdi-play" : "mdi-refresh"
          }}</v-icon>
        </v-btn>
      </div>

      <div
        v-for="stain in stains"
        :key="stain.id"
        class="stain-entity"
        :style="stainStyle(stain)"
      >
        <img :src="stain.image" :alt="stain.label" class="stain-img" />
        <div class="stain-label">{{ stain.label }}</div>

        <div v-if="turboActive" class="turbo-target-glow"></div>
      </div>
    </div>
    <div class="controls-section">
      <div class="enzyme-grid">
        <button
          v-for="enzyme in enzymes"
          :key="enzyme.type"
          @click="attack(enzyme.type)"
          :disabled="
            !playing ||
            (turboActive && activeTurboType && activeTurboType !== enzyme.type)
          "
          class="enzyme-card"
        >
          <div class="img-wrapper">
            <img :src="enzyme.icon" class="enzyme-icon-img" />
          </div>
          <span class="enzyme-lbl">{{ enzyme.name }}</span>
        </button>

        <button
          class="enzyme-card turbo-btn-cell"
          @click="activateTurbo"
          :disabled="!turboReady || !playing"
        >
          <div
            class="img-wrapper"
            :class="{ 'turbo-ready-active': turboReady }"
          >
            <img
              src="@/assets/images/game/oxygen.gif"
              class="enzyme-icon-img"
            />
            <div v-if="turboReady" class="pulse-ring"></div>
          </div>
          <span class="enzyme-lbl">{{
            turboReady ? "اکسیژن آماده!" : 300 - (score % 300) + " تا توربو"
          }}</span>
        </button>
      </div>
    </div>

    <v-dialog
      v-model="gameOverDialog"
      persistent
      max-width="350"
      class="dialog"
    >
      <v-card class="game-over-card dialog text-center pa-6 pt-2">
        <img src="@/assets/images/game/logo.gif" class="logo" />
        <div class="final-score-badge">{{ score }}</div>
        <h2 class="blue--text text--darken-4 mt-4">بازی تمام شد!</h2>
        <v-text-field
          v-model="phoneInput"
          label="شماره موبایل برای ثبت امتیاز"
          outlined
          dense
          class="mt-2 rounded-lg"
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          maxlength="11"
          placeholder="09123456789"
          :rules="phoneRules"
          :disabled="submitting"
          @keypress="restrictToDigits($event)"
          autofocus
          @v-paste="handlePaste"
        ></v-text-field>
        <img src="@/assets/images/game/sepidfinal.gif" class="final" />
        <v-btn
          class="btn-warning rounded-lg mt-2"
          block
          @click="save()"
          :disabled="!validPhone || submitting"
          >ثبت </v-btn
        ><v-btn class="btn-warning rounded-lg mt-2" block @click="Restart()">
          دوباره بازی</v-btn
        >
        <v-btn class="btn-warning rounded-lg mt-2" block @click="close()"
          >بعداً</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPhoneModal" max-width="300">
      <v-card class="rounded-xl pa-4">
        <v-card-title class="text-h6 justify-center"
          >تغییر شماره موبایل</v-card-title
        >
        <v-card-text>
          <v-text-field
            v-model="phoneEditInput"
            label="شماره موبایل جدید"
            placeholder="09123456789"
            outlined
            dense
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="11"
            :rules="phoneRules"
            @keypress="restrictToDigits($event)"
            @v-paste="handlePaste"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="grey lighten-1" text @click="showPhoneModal = false"
            >انصراف</v-btn
          >
          <v-btn color="primary" class="rounded-lg" @click="updatePhoneNumber"
            >ذخیره</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EnzymeSquad",

  data() {
    return {
      showPhoneModal: false,
      phoneEditInput: localStorage.getItem("user_phone") || "",
      gamePaused: false,
      currentTurboPoints: 0,
      phoneNumber: localStorage.getItem("user_phone") || "",
      phoneInput: localStorage.getItem("user_phone") || "",
      submitting: false,
      phoneError: "",
      turboReady: false,
      playing: false,
      showTutorial: true,
      score: 0,
      lives: 3,
      timeLeft: 45,
      stains: [],
      turboActive: false,
      activeTurboType: null,
      gameOverDialog: false,
      isMuted: false,
      spawnInterval: null,
      timerInterval: null,
      particles: [],
      // تنظیمات آنزیم‌ها
      enzymes: [
        {
          type: "protease",
          name: "پروتئاز",
          icon: require("@/assets/images/game/btn_p.webp"),
        },
        {
          type: "lipase",
          name: "لیپاز",
          icon: require("@/assets/images/game/btn_o.webp"),
        },
        {
          type: "amylase",
          name: "آمیلاز",
          icon: require("@/assets/images/game/btn_s.webp"),
        },
        {
          type: "cellulase",
          name: "سلولاز",
          icon: require("@/assets/images/game/btn_g.webp"),
        },
        {
          type: "mannanase",
          name: "ماناناز",
          icon: require("@/assets/images/game/btn_jelly.webp"),
        },
      ],
      stainTypes: [
        {
          type: "protein",
          image: require("@/assets/images/game/boold.webp"),
          color: "#FF5252",
        },
        {
          type: "fat",
          image: require("@/assets/images/game/oil.webp"),
          color: "#FFAB40",
        },
        {
          type: "starch",
          image: require("@/assets/images/game/ketchup.webp"),
          color: "#FFD740",
        },
        {
          type: "fiber",
          image: require("@/assets/images/game/fiber.webp"),
          color: "#69F0AE",
        },
        {
          type: "sticky",
          image: require("@/assets/images/game/jelly.webp"),
          color: "#448AFF",
        },
      ],
      guideItems: [
        {
          type: "protein",
          label: "لکه خون",
          stain: require("@/assets/images/game/boold.webp"),
          eName: "پروتئازِ خون‌خوار",
          enzyme: require("@/assets/images/game/btn_p.webp"),
        },
        {
          type: "fat",
          label: "لکه روغن",
          stain: require("@/assets/images/game/oil.webp"),
          eName: "لیپازِ چربی‌سور",
          enzyme: require("@/assets/images/game/btn_o.webp"),
        },
        {
          label: "لکه سس",
          stain: require("@/assets/images/game/ketchup.webp"),
          eName: "آمیلازِ نشاسته‌شکن",
          enzyme: require("@/assets/images/game/btn_s.webp"),
          type: "starch",
        },
        {
          type: "fiber",
          label: "پرز لباس",
          stain: require("@/assets/images/game/fiber.webp"),
          eName: "سلولازِ سفیدکننده",
          enzyme: require("@/assets/images/game/btn_g.webp"),
        },
        {
          type: "sticky",
          label: "لکه ژله",
          stain: require("@/assets/images/game/jelly.webp"),
          type: "mannanase",
          eName: "مانازِ چسب گشا",
          enzyme: require("@/assets/images/game/btn_jelly.webp"),
        },
      ],
      phoneRules: [
        (v) => !!v || "شماره موبایل الزامی است",
        (v) => (v && v.length === 11) || "شماره باید دقیقاً ۱۱ رقم باشد",
        (v) =>
          (v && /^09[0-9]{9}$/.test(v)) ||
          "شماره باید با ۰۹ شروع شود و فقط عدد باشد",
      ],
    };
  },
  computed: {
    validPhone() {
      return /^09[0-9]{9}$/.test(this.phoneInput);
    },
  },
  mounted() {
    this.showTutorial =
      !localStorage.getItem("sepid_game_tutorial_seen") || true;
  },
  methods: {
    restrictToDigits(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text",
      );
      if (!/^[0-9]{1,11}$/.test(pasted)) {
        event.preventDefault();
      }
    },
    Restart() {
      this.gameOverDialog = false;
      this.startGame();
    },
    checkAndSubmitSavedPhone() {
      const savedPhone = localStorage.getItem("user_phone");
      if (savedPhone && /^09\d{9}$/.test(savedPhone)) {
        this.submitScore(savedPhone);
        this.$toast.success("شماره قبلی یافت شد – امتیاز ثبت شد!");
      } else {
        this.gameOverDialog = true;
      }
    },
    async submitScore(phone) {},
    close() {
      this.gameOverDialog = false;
      this.$emit("close");
    },
    openEditPhone() {
      this.phoneEditInput = this.phoneNumber;
      this.showPhoneModal = true;
      if (this.playing) this.togglePause();
    },
    async updatePhoneNumber() {
      if (!this.phoneEditInput || this.phoneEditInput.length !== 11) {
        this.$toast.error("لطفاً یک شماره معتبر ۱۱ رقمی وارد کنید.");
        return;
      }

      localStorage.setItem("user_phone", this.phoneEditInput);
      this.phoneNumber = this.phoneEditInput;
      this.phoneInput = this.phoneEditInput;
      this.showPhoneModal = false;

      await this.submitScore(this.phoneEditInput);

      this.$toast.success("شماره با موفقیت بروزرسانی و امتیاز ثبت شد.");
    },
    togglePause() {
      this.gamePaused = !this.gamePaused;
      this.playing = !this.gamePaused;

      if (this.playing) {
        this.startSpawning();
      } else {
        clearTimeout(this.spawnInterval);
      }
    },
    destroyStain(stain, isTurbo) {
      this.createParticles(stain);
      this.stains = this.stains.filter((s) => s.id !== stain.id);

      const points = isTurbo ? 15 : 10;
      this.score += points;

      if (!this.turboReady) {
        this.currentTurboPoints += points;
        if (this.currentTurboPoints >= 300) {
          this.turboReady = true;
          this.vibrate(100);
        }
      }
    },
    startGame() {
      localStorage.setItem("sepid_game_tutorial_seen", "true");
      this.showTutorial = false;
      this.playing = true;
      this.gamePaused = false;
      this.score = 0;
      this.lives = 3;
      this.timeLeft = 45;
      this.stains = [];
      this.turboReady = false;
      this.startSpawning();
      this.startTimer();
      this.animateParticles();
    },

    toggleMute() {
      this.isMuted = !this.isMuted;
    },
    bubbleStyle(i) {
      return {
        left: `${Math.random() * 100}%`,
        bottom: `${Math.random() * 100}%`,
        animationDelay: `${i * 0.2}s`,
        backgroundImage: `url(${require("@/assets/images/game/powder-turbo.webp")})`,
        backgroundSize: "contain",
        opacity: 0.5 + Math.random() * 0.5,
        width: "30px",
        height: "30px",
      };
    },
    // سیستم پخش صدا (تولید فرکانس در صورت نبود فایل)
    playSound(type) {
      if (this.isMuted) return;
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();

      osc.connect(gain);
      gain.connect(audioCtx.destination);

      if (type === "hit") {
        osc.type = "sine";
        osc.frequency.setValueAtTime(440, audioCtx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(
          0.01,
          audioCtx.currentTime + 0.1,
        );
        gain.gain.setValueAtTime(0.1, audioCtx.currentTime);
        osc.start();
        osc.stop(audioCtx.currentTime + 0.1);
      } else if (type === "error") {
        osc.type = "sawtooth";
        osc.frequency.setValueAtTime(100, audioCtx.currentTime);
        gain.gain.setValueAtTime(0.05, audioCtx.currentTime);
        osc.start();
        osc.stop(audioCtx.currentTime + 0.2);
      } else if (type === "turbo") {
        osc.type = "triangle";
        osc.frequency.setValueAtTime(200, audioCtx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(
          800,
          audioCtx.currentTime + 0.5,
        );
        gain.gain.setValueAtTime(0.1, audioCtx.currentTime);
        osc.start();
        osc.stop(audioCtx.currentTime + 0.5);
      }
    },

    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.endGame();
        }
      }, 1000);
    },

    startSpawning() {
      const spawn = () => {
        if (!this.playing) return;
        this.spawnStain();
        const nextRate = Math.max(600, 1400 - this.score * 1.8);
        this.spawnInterval = setTimeout(spawn, nextRate);
      };
      spawn();

      // شروع انیمیشن مرکزی حرکت لکه‌ها
      this.updateStainsPosition();
    },

    spawnStain() {
      const typeInfo =
        this.stainTypes[Math.floor(Math.random() * this.stainTypes.length)];

      const labelMap = {
        protein: "خون",
        fat: "روغن",
        starch: "سس",
        fiber: "الیاف",
        sticky: "ژله",
      };

      const id = Date.now() + Math.random();
      this.stains.push({
        id,
        ...typeInfo,
        label: labelMap[typeInfo.type],
        x: 10 + Math.random() * 75,
        y: -10,
        speed: 0.1 + this.score / 1400 + Math.random() * 0.1,
      });
      this.moveStain(id);
    },
    moveStain(id) {
      const move = () => {
        const stain = this.stains.find((s) => s.id === id);
        if (stain && this.playing) {
          stain.y += stain.speed;
          if (stain.y > 105) {
            this.loseLife();
            this.stains = this.stains.filter((s) => s.id !== id);
          } else {
            requestAnimationFrame(move);
          }
        }
      };
      move();
    },

    attack(enzymeType) {
      const match = {
        protease: "protein",
        lipase: "fat",
        amylase: "starch",
        cellulase: "fiber",
        mannanase: "sticky",
      };
      const targetType = match[enzymeType];

      if (this.turboActive) {
        const targets = this.stains.filter((s) => s.type === targetType);
        if (targets.length > 0) {
          targets.forEach((s) => this.destroyStain(s, true));
          this.playSound("hit");
        }
      } else {
        // پیدا کردن لکه‌ای که از همه پایین‌تر است (بیشترین y)
        const targets = this.stains.filter((s) => s.type === targetType);
        if (targets.length > 0) {
          const lowest = targets.reduce((prev, current) =>
            prev.y > current.y ? prev : current,
          );
          this.destroyStain(lowest, false);
          this.playSound("hit");
        } else {
          this.score = Math.max(0, this.score - 5);
          this.playSound("error");
          this.vibrate(50);
        }
      }
    },

    activateTurbo() {
      if (!this.turboReady || this.gamePaused) return;
      this.turboActive = true;
      this.turboReady = false;
      this.currentTurboPoints = 0;

      this.playSound("turbo");
      this.vibrate([100, 50, 100]);

      this.stains.forEach((s) => this.destroyStain(s, true));

      setTimeout(() => {
        this.turboActive = false;
      }, 2000);
    },

    savePhoneNumber() {
      if (this.phoneInput.length === 11) {
        localStorage.setItem("user_phone", this.phoneInput);
        this.phoneNumber = this.phoneInput;
        let leaderBoard = JSON.parse(
          localStorage.getItem("leaderboard") || "[]",
        );
        leaderBoard.push({
          phone: this.phoneNumber,
          score: this.score,
          date: new Date(),
        });
        localStorage.setItem("leaderboard", JSON.stringify(leaderBoard));
      }
    },
    loseLife() {
      this.lives--;
      this.vibrate(200);
      this.playSound("error");
      if (this.lives <= 0) this.endGame();
    },
    endGame() {
      this.playing = false;
      clearTimeout(this.spawnInterval);
      clearInterval(this.timerInterval);
      this.gameOverDialog = true;

      this.checkAndSubmitSavedPhone();
    },
    async save() {
      if (!this.phoneInput || this.phoneInput.length !== 11) {
        this.$toast.success("لطفاً یک شماره ۱۱ رقمی معتبر وارد کنید!");
        return;
      }

      localStorage.setItem("user_phone", this.phoneInput);
      this.phoneNumber = this.phoneInput;
      this.phoneInput = this.phoneInput;

      await this.submitScore(this.phoneInput);

      this.gameOverDialog = false;
      this.$toast.success("شماره و امتیاز ثبت شد!");
    },
    createParticles(stain) {
      const rect = this.$refs.gameArea.getBoundingClientRect();
      const startX = (stain.x / 100) * rect.width;
      const startY = (stain.y / 100) * rect.height;

      for (let i = 0; i < 15; i++) {
        this.particles.push({
          x: startX,
          y: startY,
          vx: (Math.random() - 0.5) * 12,
          vy: (Math.random() - 0.5) * 12,
          color: stain.color,
          life: 1.0,
          size: Math.random() * 5 + 2,
        });
      }
    },

    animateParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;

      const render = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.particles.forEach((p, i) => {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += 0.2; // Gravity
          p.life -= 0.025;
          ctx.fillStyle = p.color;
          ctx.globalAlpha = p.life;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fill();
          if (p.life <= 0) this.particles.splice(i, 1);
        });
        if (this.playing || this.particles.length > 0)
          requestAnimationFrame(render);
      };
      render();
    },
    updateStainsPosition() {
      if (!this.playing) return;

      this.stains = this.stains
        .map((stain) => {
          const newY = stain.y + stain.speed;
          if (newY > 105) {
            this.loseLife();
            return null; // حذف لکه
          }
          return { ...stain, y: newY };
        })
        .filter(Boolean);

      requestAnimationFrame(this.updateStainsPosition);
    },
    vibrate(pattern) {
      if (navigator.vibrate) navigator.vibrate(pattern);
    },

    stainStyle(stain) {
      return {
        left: stain.x + "%",
        top: stain.y + "%",
        transform: `translate(-50%, -50%) scale(${1 + stain.y / 400})`,
      };
    },
  },
};
</script>

<style scoped>
.enzyme-game-pro {
  position: relative;
  height: 95vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #f8529d, #f8529d00);
  font-family: "Vazir", sans-serif;
  user-select: none;
  overflow: hidden;
}

/* Header Styles */
.game-header {
  height: 55px;
  background: linear-gradient(to bottom, #f770adb0, #e91e63b0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  color: white;
  z-index: 100;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  justify-content: center;
  align-content: center;
  align-items: center;
}

.score-chip {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 10px;
  border-radius: 15px;
  font-weight: bold;
  font-size: 14px;
}

.lives-box {
  display: flex;
  align-items: center;
}
.heart-icon {
  width: 22px;
  height: 22px;
  margin: 0 1px;
}

.user-info {
  font-size: 11px;
  background: rgba(0, 0, 0, 0.2);
  padding: 4px 8px;
  border-radius: 10px;
  cursor: pointer;
}

.particle-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5;
}

/* Tutorial Overlay */
.tutorial-overlay {
  position: absolute;
  inset: 0;
  background: rgba(8, 0, 0, 0.747) !important;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(10px);
}

.tutorial-card {
  background: linear-gradient(to bottom, #ffffff, #f8d7da);
  width: 100%;
  max-width: 80%;
  border-radius: 25px;
  padding: 20px;
  padding-top: 5px !important;
  text-align: center;
  color: goldenrod;
  border: 2px solid goldenrod;
  backdrop-filter: blur(5px) !important;
}

/* .guide-scroll {
  width: 100%;
  max-height: 280px;
  overflow: hidden;
  position: relative;
  margin: 15px 0;
} */

.guide-row {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  background: #f0f4f8;
  margin-bottom: 2px;
  border-radius: 15px;
  width: max-content;

  padding: 2px;
  border: 2px solid goldenrod;
}

.g-stain img,
.g-enzyme img {
  width: 30px;
  height: 30px;
  display: block;
  margin: 0 auto;
}
.g-stain span,
.g-enzyme span {
  font-size: 10px;
  font-weight: bold;
}

/* Turbo Effects */
.turbo-screen-effect {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 15;
}

.oxygen-flash {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.4) 0%,
    transparent 70%
  );
  animation: flash 0.5s infinite alternate;
}

.bg-bubble-1,
.bg-bubble-2 {
  position: absolute;
  width: 120px;
  opacity: 0.4;
}
.bg-bubble-1 {
  top: 10%;
  left: -20px;
  animation: float 3s infinite;
}
.bg-bubble-2 {
  bottom: 20%;
  right: -20px;
  animation: float 4s infinite reverse;
}

/* Controls */
.controls-section {
  background: rgba(255, 255, 255, 0.56);
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.3);
  z-index: 110;
  padding: 8px 6px 14px;
  border-radius: 32px 32px 0 0;
  z-index: 110;
  border: 4px solid rgb(210, 160, 35);
  backdrop-filter: blur(10px);
  flex-shrink: 0;
  min-height: 110px !important;
  position: absolute;
  width: 100% !important;
  bottom: 2px;
}

.turbo-area {
  height: 65px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.turbo-ready-btn {
  background: linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%);
  border: 4px solid #fff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  padding: 0px 2px;
  color: white;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.turbo-ready-btn img {
  width: 45px;
  margin-left: 10px;
}
.turbo-ready-btn .top {
  display: block;
  font-weight: bold;
  font-size: 16px;
}
.turbo-ready-btn .bottom {
  font-size: 10px;
  opacity: 0.9;
}

.enzyme-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1px;
}

.enzyme-card {
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.1s;
  background: transparent;
  padding: 0px;
}

.enzyme-card:active {
  transform: scale(0.85);
}
.enzyme-card:disabled {
  opacity: 0.3;
  filter: grayscale(1);
}

.img-wrapper {
  background: transparent;
  border-radius: 18px;
  padding: 0px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.05);
  margin-bottom: 5px;
}

.enzyme-icon-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.enzyme-lbl {
  font-size: 10px;
  font-weight: bold;
  color: #df0707;
  text-shadow: white;
}

.final-score-badge {
  width: 80px;
  height: 80px;
  background: rgba(218, 165, 32, 0.925);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 28px;
  font-weight: bold;
  color: #5f1a39;
  border: 4px solid #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.finish-product-img {
  width: 140px;
  margin: 10px auto;
  border-radius: 55%;
  border: 2px solid darkgoldenrod;
  margin: 0px;
}

/* Animations */
@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(-20px) rotate(10deg);
  }
}

@keyframes flash {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 0.6;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.goldenrod {
  color: goldenrod;
}
.iconOxygen {
  width: 30px;
  height: auto;
}

.btn-warning:hover {
  color: #ffa800 !important;
  border-color: #ffa800 !important;
  border: 2px solid #ffa800 !important;
  background: #f9fafc !important;
}

.btn-warning {
  color: #f9fafc !important;
  background-color: #ffa800 !important;
  border-color: #ffa800 !important;
  animation: pulse-glow_gold 1s infinite alternate;
}

.btn-warning:focus,
.btn-warning.focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 168, 0, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(255, 168, 0, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #ffa800;
  background-color: transparent;
}

.btn-warning:not(:disabled):not(.disabled):active,
.btn-warning:not(:disabled):not(.disabled).active,
.show > .btn-warning.dropdown-toggle {
  color: #f7f7fa;
  background-color: #ffa800;
  border-color: #ffa800;
}

.btn-warning:not(:disabled):not(.disabled):active:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 168, 0, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(255, 168, 0, 0.5);
}
.turbo-bubbles {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}

.bubble {
  position: absolute;
  border-radius: 50%;
  background: rgba(200, 240, 255, 0.4);
  backdrop-filter: blur(2px);
  animation: rise 4s linear infinite;
}

@keyframes rise {
  0% {
    transform: translateY(120%);
    opacity: 0;
  }
  30% {
    opacity: 0.7;
  }
  100% {
    transform: translateY(-120%);
    opacity: 0;
  }
}
.turbo-is-ready {
  filter: drop-shadow(0 0 10px #00fbff);
  animation: glowing 1.5s infinite;
  transform: scale(1.1);
}

@keyframes glowing {
  0% {
    filter: drop-shadow(0 0 5px #00fbff);
  }
  50% {
    filter: drop-shadow(0 0 20px #00fbff);
  }
  100% {
    filter: drop-shadow(0 0 5px #00fbff);
  }
}

.enzyme-card:disabled {
  filter: grayscale(1);
  opacity: 0.6;
  cursor: not-allowed;
}
.turbo-ready-active {
  filter: drop-shadow(0 0 8px #00e5ff);
  animation: pulse-glow 1s infinite alternate;
  background: rgba(0, 229, 255, 0.2) !important;
  border-radius: 50%;
}

@keyframes pulse-glow {
  from {
    transform: scale(1);
    box-shadow: 0 0 5px #00e5ff;
  }
  to {
    transform: scale(1.1);
    box-shadow: 0 0 20px #00e5ff;
  }
}
@keyframes pulse-glow_gold {
  from {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(255, 170, 0, 0.315);
  }
  to {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(255, 170, 0, 0.144);
  }
}

.enzyme-card:disabled {
  opacity: 0.5;
  filter: grayscale(1);
}
.icon-header {
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  background: #f9fbfc38;
  backdrop-filter: blur(10px);
  padding: 2px;
}
.lives-and-audio {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
/* تنظیمات اصلی هدر */
.game-header {
  height: 70px; /* کمی بلندتر برای خوانایی بهتر */
  background: linear-gradient(to bottom, #fa5ca3, #e91e63);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  color: white;
  z-index: 100;
  border-bottom: 3px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* بخش‌های جانبی */
.header-right,
.header-left {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  flex: 1;
}
.header-right2 {
  display: flex !important;
  flex-direction: row !important;
  gap: 5px;
  align-items: flex-end;
  flex: 1;
  justify-content: flex-end !important;
}
.header-right {
  align-items: flex-start;
}
.header-left {
  align-items: flex-end;
}

/* بخش مرکز (تایمر و امتیاز) */
.header-center {
  flex: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 0 0 20px 20px;
  padding: 5px 10px;
  height: 100%;
}

/* استایل تایمر */
.timer-display {
  font-weight: 900;
  line-height: 1;
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.time-num {
  font-size: 24px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.time-unit {
  font-size: 10px;
  opacity: 0.9;
}
.low-time .time-num {
  color: #ffeb3b;
  animation: pulse 0.5s infinite;
}

/* استایل امتیاز */
.score-display {
  font-size: 13px;
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 12px;
  border-radius: 20px;
  margin-top: 4px;
}

/* دکمه‌های آیکون‌دار */
.icon-header {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(5px);
  width: 30px !important;
  height: 30px !important;
}

/* اطلاعات کاربر */
.user-info-mini {
  font-size: 10px;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 6px;
  border-radius: 8px;
  margin-top: 5px;
}
.phone-text {
  margin-right: 4px;
  max-width: 80px;
  overflow: hidden;
}

@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}

.heart-icon {
  width: 18px;
  height: 18px;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
}

.stain-entity {
  position: absolute;
  width: 64px;
  height: 64px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.65));
}

.stain-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.65)) contrast(1.15)
    brightness(1.08);
}

.stain-label {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 11px;
  font-weight: bold;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
  padding: 1px 6px;
  border-radius: 10px;
  margin-top: 4px;
  pointer-events: none;
  text-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.game-viewport {
  flex: 1;
  position: relative;
  background: url("~@/assets/images/game/background1.webp") center bottom/cover;
  overflow: hidden;
  z-index: 1;
}
game-viewport::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  pointer-events: none;
  z-index: 2;
}
.logo {
  width: 98px;
  margin-bottom: 10px;
}
.final {
  width: 100px;
  height: auto;
  border-radius: 50px;
  border: 2px solid goldenrod;
  margin: 0px !important;
}
@keyframes point-down {
  0% {
    transform: translateY(0);
    opacity: 0.5;
  }
  50% {
    transform: translateY(5px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
}

.animated-arrow {
  animation: point-down 1s infinite;
  color: #daa520 !important;
}
.guide-scroll {
  width: 100%;
  overflow: hidden;
  margin: 10px 0;
  position: relative;
}

.marquee-wrapper {
  overflow: hidden;
}

.marquee-content {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  animation: scroll-left 25s linear infinite;
  will-change: transform;
  min-width: max-content;
  padding: 0px !important;
}

.guide-row {
  flex: 0 0 auto; /* اندازه ثابت، جمع نشود */
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: rgba(255, 248, 225, 0.7);
  border-radius: 16px;
  border: 2px solid goldenrod;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

@keyframes scroll-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.marquee-wrapper:hover .marquee-content {
  animation-play-state: paused;
}
.marquee-content {
  display: flex;
  animation: marquee-scroll 15s linear infinite;
}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  } /* بسته به جهت RTL تنظیم شود */
}

.guide-scroll {
  overflow: hidden;
  white-space: nowrap;
  margin: 20px 0;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 15px;
}
.game-over-card {
  overflow: hidden !important;
  height: fit-content;
  overflow-y: hidden !important;
}
.dialog {
  max-width: 350px !important;
  overflow: hidden !important;
  height: fit-content !important;
  border-radius: 41px !important;
  border: 4px solid goldenrod !important;
  height: fit-content;
  background: linear-gradient(to bottom, #ffffff, #fcc6de) !important;
  overflow-y: hidden !important;
}
</style>
